import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConstants } from '../constants/constants';
import { ActivityLogsResponse, User } from 'src/app/core/user/user.types';
import { environment } from "src/environments/environment";
import { UserState } from './state/user.state';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(private _httpClient: HttpClient, private _sanitizer: DomSanitizer) { }

	/**
	 * Get the current logged in user data
	 */
	get(): Observable<User> {
		const url = AppConstants.API.USERS_API;
		return this._httpClient.get<User>(url).pipe(
			tap((user: any) => {
				let currentUser: User = {
					...user,
					firstName: user.fullName.split(" ")[0],
				}
				let pessmision: string[] = [];

				currentUser.permissions.forEach((permissionGroup: any) => {
					permissionGroup.permissions.forEach((singlePermission: any) => {
						if (singlePermission.enabled) {
							pessmision.push(singlePermission.value)
						}
					})
				});
				localStorage.setItem(AppConstants.PRISISTED_KEYS.USER_PERMISSIONS, JSON.stringify(pessmision));
				UserState.setUserState(currentUser);
			})
		);
	}

	/**
	 * Get the current logged in user photo
	 */
	getProfilePhoto(): Observable<any> {
		const url = `${AppConstants.API.PROFILE_API}/photo`;;
		return this._httpClient.get(url, { responseType: 'blob' }).pipe(
			tap((img: any) => {
				let objectURL = window.URL.createObjectURL(img);
				let userPhoto = this._sanitizer.bypassSecurityTrustUrl(objectURL);
				UserState.setUserPhotoState(userPhoto);
			})
		);
	}


	/**
	 * get Current User ActivityLogs
	 */
	getCurrentUserActivityLogs(page = 0, size = 10): Observable<ActivityLogsResponse> {
		const url = `${AppConstants.API.PROFILE_API}/activityLog?page=${page}&size=${size}`;
		return this._httpClient.get<ActivityLogsResponse>(url);
	}
}